import { Component, EventEmitter, Output, Input, OnInit } from '@angular/core';

import { FormBuilder } from '@angular/forms';
import { UserService } from '@athlete-x/shared';
import { User } from '@athlete-x/definitions';
import { switchMap } from 'rxjs';

@Component({
    selector: 'atx-directory-global-visiblity',
    templateUrl: './directory-global-visiblity.component.html',
    styleUrls: ['./directory-global-visiblity.component.scss'],
})
export class DirectoryGlobalVisiblityComponent implements OnInit {
    @Input() set user(value: User | null) {
        if (value) {
            this.form
                .patchValue(
                    {
                        privacy_only_my_city: value.privacy_only_my_city,
                        privacy_only_my_industry: value.privacy_only_my_industry,
                        privacy_only_my_college: value.privacy_only_my_college,
                        privacy_only_my_sport: value.privacy_only_my_sport
                    },
                    {
                        onlySelf: true,
                        emitEvent: false
                    }
                );
        }
    }

    @Input() autoOn = false;

    @Input() editing = false;
    @Input() processing = false;

    @Output() valueChanges = new EventEmitter();

    public form = this._formBuilder.group({
        privacy_only_my_city: [false],
        privacy_only_my_industry: [false],
        privacy_only_my_college: [false],
        privacy_only_my_sport: [false]
    });

    constructor(
        private _formBuilder: FormBuilder,
        private _userService: UserService,
    ) {
    }

    ngOnInit() {
        if (this.autoOn) {
            this.form
                .patchValue({
                    privacy_only_my_city: true,
                    privacy_only_my_industry: true,
                    privacy_only_my_college: true,
                    privacy_only_my_sport: true
                });
        }

        this.form.valueChanges
            .pipe(
                switchMap(value => this._userService.updateProfile({ ...value })),
                switchMap(() => this._userService.reload())
            )
            .subscribe(() => {
                this.valueChanges.emit({
                    ...this.form.value
                });
            });
    }
}
